import { createFileRoute } from "@tanstack/react-router";
import { TrashPage } from "@/features/filesmore/TrashPage";

export const Route = createFileRoute("/_app/files/trash")({
  component: TrashPage,
});
